const certificates_period_validation = {
    'Cert_Libre_Deuda': 1,
    'Cert_Etica': 2,
    'Cert_Matricula': 2
}

export const isInvalidPeriod = (cert, periodOwed) => {
    return typeof certificates_period_validation[cert] !== 'undefined' && periodOwed > certificates_period_validation[cert]
}
